import { Controller } from 'stimulus'

// Polls until the server renders the element without this controller.
// data-live-refresh-keep: classes the user toggles here, which the server cannot know.
export default class extends Controller {
  initialize() {
    this.refresh  = this.refresh.bind(this)
    this.interval = parseInt(this.data.get('interval'), 10) || 3000
  }

  connect() {
    this.timeout = setTimeout(this.refresh, this.interval)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  async refresh() {
    const element = this.element
    try {
      const response = await fetch(this.data.get('url') || window.location.href, {
        credentials: 'same-origin',
        headers:     { Accept: 'text/html' }
      })
      if (!response.ok) { throw new Error(response.status) }

      const page  = new DOMParser().parseFromString(await response.text(), 'text/html')
      const fresh = element.id && page.getElementById(element.id)
      if (!fresh || !element.isConnected) { return }

      this.keepClasses(element, fresh)
      element.replaceWith(fresh)
      if (window.ReactRailsUJS) { window.ReactRailsUJS.mountComponents(fresh) }
    } catch (_error) {
      if (element.isConnected) { this.timeout = setTimeout(this.refresh, this.interval) }
    }
  }

  keepClasses(element, fresh) {
    (this.data.get('keep') || '').split(' ').filter(Boolean).forEach((name) => {
      const nodes = (root) => [root, ...root.querySelectorAll('*')]
      const had   = nodes(element).map((node) => node.classList.contains(name))
      nodes(fresh).forEach((node, index) => node.classList.toggle(name, Boolean(had[index])))
    })
  }
}
